<script>
export default {}
</script>

<template>
  <header
    class="navigation relative z-header viewport-gutter w-full flex flex-shrink-0 items-center justify-between bg-primary color-white py-4 mb-4"
  >
    <div class="container w-full flex items-center justify-between">
      <div>
        <div class="logo" />
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.navigation {
  height: 60px;
}

.logo {
  height: 29px;
  width: 275px;
  background: url('~images/psp/logo-white.svg') 0 0 / 170px 29px no-repeat;

  @screen sm {
    width: 407px;
    background: url('~images/psp/logo-white.svg') 0 0 / 170px 29px no-repeat;
  }
}
</style>
